import { render } from "./BlockView.vue?vue&type=template&id=4af6bad8&scoped=true"
import script from "./BlockView.vue?vue&type=script&lang=js"
export * from "./BlockView.vue?vue&type=script&lang=js"

import "./BlockView.vue?vue&type=style&index=0&id=4af6bad8&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af6bad8"]])

export default __exports__